import { motion } from 'framer-motion'
import { Bot, Mail, MessageSquare, Plug, Sparkles, Workflow } from 'lucide-react'

const steps = [
  { id: 'prompt', label: 'Prompt', icon: MessageSquare, x: 12, y: 18 },
  { id: 'tools', label: 'Tools', icon: Plug, x: 36, y: 18 },
  { id: 'agent', label: 'Agent', icon: Sparkles, x: 62, y: 18, main: true },
  { id: 'action', label: 'Action', icon: Mail, x: 87, y: 18 },
]

const agents = [
  { id: 'onboarding', name: 'Onboarding', icon: Bot },
  { id: 'support', name: 'Soporte N1', icon: MessageSquare },
  { id: 'close', name: 'Cierre', icon: Workflow },
]

export function BuildMockup() {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden rounded-xl bg-surface-elevated p-4 shadow-2xl sm:p-5">
      <div className="flex flex-1 flex-col justify-center">
        <div className="relative w-full">
          <svg viewBox="0 0 100 42" className="h-auto w-full">
            <defs>
              <linearGradient id="build-line" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#a78bfa" />
              </linearGradient>
            </defs>

            {steps.slice(0, -1).map((step, i) => {
              const next = steps[i + 1]
              return (
                <motion.path
                  key={`${step.id}-${next.id}`}
                  d={`M ${step.x} ${step.y} L ${next.x} ${next.y}`}
                  stroke="url(#build-line)"
                  strokeWidth="0.7"
                  fill="none"
                  strokeLinecap="round"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 0.6, delay: i * 0.15 }}
                />
              )
            })}

            {steps.map((step, i) => (
              <motion.g
                key={step.id}
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.3 + i * 0.12 }}
              >
                <motion.rect
                  x={step.x - 5}
                  y={step.y - 5}
                  width={10}
                  height={10}
                  rx={1.5}
                  fill={step.main ? '#8b5cf6' : '#1e1b2e'}
                  stroke={step.main ? '#a78bfa' : '#8b5cf6'}
                  strokeWidth="0.5"
                  animate={step.main ? { strokeWidth: [0.5, 1, 0.5] } : {}}
                  transition={step.main ? { repeat: Infinity, duration: 2.5 } : {}}
                />
                <foreignObject x={step.x - 3} y={step.y - 3} width={6} height={6}>
                  <div className="flex h-full w-full items-center justify-center text-white">
                    <step.icon className="h-3 w-3" />
                  </div>
                </foreignObject>
                <text
                  x={step.x}
                  y={step.y + 10}
                  textAnchor="middle"
                  className="fill-text-secondary text-[3px] font-medium"
                >
                  {step.label}
                </text>
              </motion.g>
            ))}
          </svg>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
          className="mt-2 grid grid-cols-3 gap-2 sm:gap-3"
        >
          {agents.map((agent, i) => (
            <motion.div
              key={agent.id}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1 + i * 0.1 }}
              className="flex items-center gap-2 rounded-lg border border-border bg-surface px-2 py-2"
            >
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-accent/10 text-accent-light">
                <agent.icon className="h-3.5 w-3.5" />
              </div>
              <div className="min-w-0">
                <p className="truncate text-xs font-medium text-text-primary">{agent.name}</p>
                <p className="truncate text-[10px] text-text-muted">Agente</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  )
}
